export const apiVersion =
  process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2025-12-17'

export const dataset =
  process.env.NEXT_PUBLIC_SANITY_DATASET || 'production'

export const projectId =
  process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || 'enobe7fl'

// Use the CDN only in production to ensure local development sees live updates immediately
// Can be overridden with SANITY_USE_CDN=false to disable CDN in deployed environments
export const useCdn = process.env.SANITY_USE_CDN !== undefined
  ? process.env.SANITY_USE_CDN === 'true'
  : process.env.NODE_ENV === 'production'

// Draft preview: set SANITY_PREVIEW_DRAFTS=true only on the preview.agencyq.com
// deployment so it reads the `drafts` perspective. Production (www) leaves this unset
// and serves only published content.
export const previewDrafts = process.env.SANITY_PREVIEW_DRAFTS === 'true'

// Read token with draft access. Required when previewDrafts is true; never used otherwise.
export const readToken = process.env.SANITY_API_TOKEN
